<div class="text-center">
    <div >
        <span class="material-icons-round">{{icon}}</span>
    </div>
    <div>
        {{message}}
    </div>
</div>